module.exports = __webpack_public_path__ + "static/media/experience-tv.18bcc441.png";